import React, { useState } from "react"; //
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { ApiPost } from "../../helpers/API/ApiData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ForgotPasswordPage() {
  const [errors, setErrors] = useState<any>({});
  const navigate = useNavigate();
  const [forgotModal, setForgotModal] = useState(true);
  const [verifyModal, setVerifyModal] = useState(false);
  const [afterForgotPassword, setAfterForgotPassword] = useState(false);
  const [inputvalue, setInputvalue] = useState<any>();
  const [loading, setLoading] = useState(false);

  const handleChange = (e: any) => {
    setInputvalue({ ...inputvalue, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e: any) => {
    setLoading(true);
    await ApiPost("admin/send-email", inputvalue)
      .then((res: any) => {
        if (res?.status === 200) {
          setForgotModal(false);
          setVerifyModal(true);
        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleVerify = async (e: any) => {
    setLoading(true);
    const data: any = {
      email: inputvalue.email,
      code: inputvalue.otp,
    };
    await ApiPost("admin/verify-code", data)
      .then((res: any) => {
        if (res?.status === 200) {
          setVerifyModal(false);
          setAfterForgotPassword(true);
        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleForgotPass = (e: any) => {
    navigate("/auth/login");
  };

  const handleAfterForgotPass = async (e: any) => {
    setLoading(true);
    const data: any = {
      email: inputvalue.email,
      password: inputvalue.password,
    };
    await ApiPost("admin/after-forget", data)
      .then((res: any) => {
        if (res?.status === 200) {
          navigate("/");
        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />
      {/* Forgot Password */}
      {forgotModal && (
        <Box sx={{ maxWidth: 450, width: "100%", mx: "auto" }}>
          <Box sx={{ textAlign: "center", mb: { xs: 5, lg: 10 } }}>
            <Typography variant="h4" component="h3">
              Passwort vergessen ?
            </Typography>
            <Typography color="text.secondary" fontWeight="bold">
              Geben Sie bitte Ihre Email-Adresse ein. Wir senden Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts.
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              placeholder="email"
              type="email"
              variant="outlined"
              margin="normal"
              name="email"
              value={inputvalue?.email}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              color="brand"
              size="large"
              type="submit"
              sx={{ my: 1.5, py: 1.5 }}
              disabled={loading}
              onClick={(e) => {
                handleSubmit(e);
              }}
            >
              Einreichen
            </Button>
          </Box>
          <Typography
            onClick={(e) => handleForgotPass(e)}
            sx={{ textAlign: "center", cursor: "pointer", mt: 2 }}
          >
            Sie haben ein Konto?Anmelden
          </Typography>
        </Box>
      )}

      {/* Verify code */}
      {verifyModal && (
        <Box sx={{ maxWidth: 450, width: "100%", mx: "auto" }}>
          <Box sx={{ textAlign: "center", mb: { xs: 5, lg: 10 } }}>
            <Typography variant="h4" component="h3">
              Passwort bestätigen ?
            </Typography>
            <Typography color="text.secondary" fontWeight="bold">
              Geben Sie bitte den Bestätigungscode ein, den wir Ihnen per E-Mail gesendet haben.
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              placeholder="Email"
              type="email"
              variant="outlined"
              margin="normal"
              name="email"
              value={inputvalue?.email}
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              placeholder="OTP"
              type="text"
              variant="outlined"
              margin="normal"
              name="otp"
              value={inputvalue?.otp}
              onChange={(e) => {
                handleChange(e);
              }}
              inputProps={{ maxLength: 6, pattern: "[0-9]*", inputMode: "numeric" }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              color="brand"
              size="large"
              type="submit"
              sx={{ my: 1.5, py: 1.5 }}
              disabled={loading}
              onClick={(e) => {
                handleVerify(e);
              }}
            >
              Einreichen
            </Button>
          </Box>
        </Box>
      )}

      {/* After forgot password */}
      {afterForgotPassword && (
        <Box sx={{ maxWidth: 450, width: "100%", mx: "auto" }}>
          <Box sx={{ textAlign: "center", mb: { xs: 5, lg: 10 } }}>
            <Typography variant="h4" component="h3">
              Nach dem Passwort vergessen!
            </Typography>
            <Typography color="text.secondary" fontWeight="bold">
              Bitte geben Sie Ihr neues Passwort ein.
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              placeholder="Email"
              type="email"
              variant="outlined"
              margin="normal"
              name="email"
              value={inputvalue?.email}
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              placeholder="Passwort"
              type="password"
              variant="outlined"
              margin="normal"
              name="password"
              value={inputvalue?.password}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              color="brand"
              size="large"
              type="submit"
              sx={{ my: 1.5, py: 1.5 }}
              disabled={loading}
              onClick={(e) => {
                handleAfterForgotPass(e);
              }}
            >
              Einreichen
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
}
